'use client';
import { useMemo, useState } from 'react';
import * as styles from './accordion.styles';
import Icon from '../icon/icon';
import RoundBadge from '../RoundBadge/RoundBadge';
import { useMounted } from '@utils/hooks/useMounted';
import { Heading } from '../Heading/Heading';

type Variant = 'dropdown' | 'normal';
type Props = {
  children: React.ReactNode;
  name: string;
  open?: boolean;
  space?: 'overflowing' | 'normal';
  variant?: Variant;
  count?: number;
};
export default function Accordion(props: Props) {
  const {
    variant = 'normal',
    open = false,
    name,
    space = 'normal',
    count,
  } = props;
  const mounted = useMounted();

  const [active, setActive] = useState(open);
  const children = useMemo(() => {
    if (variant === 'dropdown') {
      return (
        <div className="absolute z-50 mt-1 w-full bg-main">
          {props.children}
        </div>
      );
    }
    return props.children;
  }, [props.children, variant]);

  return (
    <div
      className={styles.wrapper({
        space: active && variant === 'normal' ? space : 'normal',
        type: variant,
      })}>
      <div
        className={styles.headerContainer({ type: variant })}
        onClick={() => setActive(!active)}>
        <div
          className={styles.headerTitleContainer({
            state: active ? 'active' : 'inactive',
          })}>
          <Heading as="h4" className={styles.textStyles({ type: variant })}>
            {name}
          </Heading>
          {count && mounted && (
            <RoundBadge className="md:hidden">{count}</RoundBadge>
          )}
        </div>
        <div className={styles.carrotContainer()}>
          <Icon
            className={styles.iconStyle({
              state: active ? 'active' : 'inactive',
            })}
            name="carrot"
            size={16}
            color="black"
          />
        </div>
      </div>
      {active && children}
    </div>
  );
}
